/**
 * Dashboard grid configuration constants
 * These define the boundaries and constraints of the gridster dashboard
 */
export class GridConfig {
  /**
   * Maximum number of columns in the grid
   * Fixed at 50 columns for all dashboards
   */
  static readonly MAX_COLS = 50;

  /**
   * Maximum number of rows in the grid
   * Limited to 500 rows to prevent performance issues
   */
  static readonly MAX_ROWS = 500;

  /**
   * Minimum number of columns in the grid
   */
  static readonly MIN_COLS = 50;

  /**
   * Minimum number of rows in the grid
   */
  static readonly MIN_ROWS = 10;
}
